import React, { Component } from 'react';
import { object, bool, string, func, number, shape } from 'prop-types';

import './ReportFavorite.scss';

class ReportFavorite extends Component {
  static propTypes = {
    id: string,
    isFavorite: bool,
    setFavorite: func
  };
  toggleFavorite(isFavorite, event) {
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    this.props.setFavorite(isFavorite);
  }

  render() {
    return (
      <button
        aria-label={`${this.props.isFavorite ? 'Click to unfavorite this report' : 'Click to favorite this report'}`}
        className={`${this.props.isFavorite ? 'icon-star report__favorite' : 'icon-star-empty report__favorite'}`}
        onClick={this.toggleFavorite.bind(this, !this.props.isFavorite)}
      />
    );
  }
}

export default ReportFavorite;
